module.exports = __webpack_public_path__ + "img/name-4.fcd59d9d.png";